/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum testIncludeEnum {
    ALL = 'all',
    TEST = 'test',
    LIVE = 'live',
}